"use client";

import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

// Type for props passed to AdUnit
interface AdUnitProps {
  className?: string;
  style?: React.CSSProperties;
  adSlot: string;
  adFormat?: 'auto' | 'fluid' | 'rectangle' | 'horizontal' | 'vertical';
  membership: any;
}

// Dynamically import AdUnit with ssr: false
const DynamicAdUnit = dynamic(() => import('./AdUnit').then(mod => mod.AdUnit), {
  ssr: false,
});

// Wrapper component to delay rendering
export function ClientAdUnit(props: AdUnitProps) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Render null on the server and until the component is mounted on the client
  if (!isMounted || (props.membership == 'noads')) {
    return null;
  }

  // Render the actual ad unit after mount
  return <DynamicAdUnit {...props} />;
} 